import { render, staticRenderFns } from "./UserFeatureSelect.vue?vue&type=template&id=4d9a6320&scoped=true&"
import script from "./UserFeatureSelect.vue?vue&type=script&lang=js&"
export * from "./UserFeatureSelect.vue?vue&type=script&lang=js&"
import style0 from "./UserFeatureSelect.vue?vue&type=style&index=0&id=4d9a6320&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d9a6320",
  null
  
)

export default component.exports